import React, { Component } from 'react';
import Parse from 'parse';

export default class Login extends Component {
  constructor(props) {
      super(props);
      this.state = ({
        username : null,
        password : null,
      })
  }
  parseLogin = () => {
    Parse.User.logIn(this.state.username, this.state.password, {
      success: (user) => {
        this.props.isAuthenticated()
      },
      error: function(user, error) {
        alert(error.message)
      }
    });
  }
  usernameUpdate = (e) => {
    var username = e.target.value.toLowerCase()
    this.setState({username:username});
  }
  passwordUpdate = (e) => {
    this.setState({password:e.target.value});
  }
  handleKeyPress = (e) => {
    if(e.key == 'Enter'){
      this.parseLogin()
    }
  }
  render() {
    return (
      <div className="full-height full-width row primary-background" style={{height:'100vh'}}>
        <div className="full-width large-padding" style={{margin:'auto', textAlign:"center", maxWidth:"800px"}}>
          <img className="three-quarter-width" src="img/logo.png" alt="Alpine" style={{maxWidth:'200px'}} />
          <h4 style={{color:'#fff'}}>{'Admin Login'}</h4>
          <div className="tiny-padding">
            <input
              type="text"
              style={{padding:'25px'}}
              value={this.state.username}
              onChange={this.usernameUpdate}
              onKeyPress={this.handleKeyPress}
              placeholder={'Username'} />
          </div>
          <div className="tiny-padding">
            <input
              type="password"
              style={{padding:'25px'}}
              value={this.state.password}
              onChange={this.passwordUpdate}
              onKeyPress={this.handleKeyPress}
              placeholder={'Password'} />
          </div>
          <div className="tiny-padding">
            <div className="button black-background white full-width" style={{margin:'0px',padding:'25px'}} onClick={this.parseLogin}>Login</div>
          </div>
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/login.js